var React = require('react');

function TrackCurved (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"18.8284","y":"16","width":"38","height":"4","transform":"rotate(45 18.8284 16)","fill":"#3F3F3F","key":0}),React.createElement("rect",{"x":"37.8637","y":"6","width":"38","height":"4","transform":"rotate(75 37.8637 6)","fill":"#3F3F3F","key":1}),React.createElement("rect",{"x":"7.03528","y":"34","width":"38","height":"4","transform":"rotate(15 7.03528 34)","fill":"#3F3F3F","key":2}),React.createElement("path",{"d":"M14 48C14 29.2223 29.2223 14 48 14","stroke":"black","strokeWidth":"4","key":3}),React.createElement("path",{"d":"M34 48C34 40.268 40.268 34 48 34","stroke":"black","strokeWidth":"4","key":4})]);
}

TrackCurved.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = TrackCurved;

TrackCurved.default = TrackCurved;
